import { createClient } from "@sanity/client";

let sanityClient = null;
try {
  const projectId = process.env.REACT_APP_SANITY_PROJECT_ID;
  if (projectId) {
    const isPreview = process.env.REACT_APP_SANITY_PREVIEW === "true";
    sanityClient = createClient({
      projectId,
      dataset:     process.env.REACT_APP_SANITY_DATASET || "production",
      apiVersion:  "2024-01-01",
      useCdn:      !isPreview,
      token:       isPreview ? process.env.REACT_APP_SANITY_TOKEN : undefined,
      perspective: isPreview ? "previewDrafts" : "published",
    });
  }
} catch {
  // Invalid or missing credentials — blog falls back to local articles
}

export default sanityClient;
